import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/veesoai-light.svg")